import React, { useEffect, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Collapse, TextField, Grid, Box } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

const FILTER_STATE_INIT = {
    nombre:     '',
    estado:     null,
    fechaDesde: '',
    fechaHasta: '',
};

const QUERY_INIT = {
    nombre:     '',
    estado:     '',
    fechaDesde: '',
    fechaHasta: '',
};

const ProgramasPreventivosGridFiltros = (props) => {
    const intl = useIntl();

    const [filtersState, setFiltersState] = useState({ ...FILTER_STATE_INIT });

    const estados = [
        { label: intl.formatMessage({ id: 'programasPreventivosGridFiltros.estado.borrador',  defaultMessage: 'Borrador'  }), value: 'BORRADOR'  },
        { label: intl.formatMessage({ id: 'programasPreventivosGridFiltros.estado.vigente', defaultMessage: 'Vigente' }), value: 'VIGENTE' },
        { label: intl.formatMessage({ id: 'programasPreventivosGridFiltros.estado.cerrado',   defaultMessage: 'Cerrado'   }), value: 'CERRADO'   },
    ];

    useEffect(() => {
        if (props.filterResetInputs) {
            setFiltersState({ ...FILTER_STATE_INIT });
            props.setFilterQuery({ ...QUERY_INIT });
            props.setFilterResetInputs(false);
        }
    }, [props.filterResetInputs]);

    useEffect(() => {
        if (!props.dropdownActive) {
            props.setFilterResetInputs(false);
        }
    }, [props.dropdownActive]);

    const queryTable = () => ({
        nombre:     filtersState.nombre,
        estado:     filtersState.estado ? filtersState.estado.value : '',
        fechaDesde: filtersState.fechaDesde,
        fechaHasta: filtersState.fechaHasta,
    });

    const handleChange = (name, value) => {
        setFiltersState((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        props.setFilterQuery(queryTable());
    };

    const handleSubmitInto = (e) => {
        handleSubmit(e);
    };

    return (
        <Collapse in={props.dropdownActive}>
            <Grid container item xs={12} spacing={3} style={{ marginBottom: 20 }}>

                <Grid component={Box} item xs={3}>
                    <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                        <TextField
                            label={intl.formatMessage({ id: 'programasPreventivosGridFiltros.nombre', defaultMessage: 'Nombre' })}
                            name="nombre"
                            value={filtersState.nombre}
                            onChange={(e) => handleChange('nombre', e.target.value)}
                            className="col-12"
                        />
                    </form>
                </Grid>

                <Grid component={Box} item xs={2}>
                    <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                        <Autocomplete
                            name="estado"
                            options={estados}
                            value={filtersState.estado}
                            getOptionLabel={(option) => (option ? option.label : '')}
                            onChange={(e, value) => handleChange('estado', value)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="standard"
                                    label={intl.formatMessage({ id: 'programasPreventivosGridFiltros.estado', defaultMessage: 'Estado' })}
                                />
                            )}
                        />
                    </form>
                </Grid>

                <Grid component={Box} item xs={2}>
                    <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                        <TextField
                            label={intl.formatMessage({ id: 'programasPreventivosGridFiltros.fecha_desde', defaultMessage: 'Inicio desde' })}
                            name="fechaDesde"
                            type="date"
                            value={filtersState.fechaDesde}
                            onChange={(e) => handleChange('fechaDesde', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            className="col-12"
                        />
                    </form>
                </Grid>

                <Grid component={Box} item xs={2}>
                    <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                        <TextField
                            label={intl.formatMessage({ id: 'programasPreventivosGridFiltros.fecha_hasta', defaultMessage: 'Inicio hasta' })}
                            name="fechaHasta"
                            type="date"
                            value={filtersState.fechaHasta}
                            onChange={(e) => handleChange('fechaHasta', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            className="col-12"
                        />
                    </form>
                </Grid>

                <Grid xs={12} container justifyContent="flex-end" alignItems="center">
                    <Grid component={Box} item className="align-self-end">
                        <button type="button" className="btn btn-primary mr-1" onClick={handleSubmit}>
                            <i className="fa fa-search fa-xs"></i>{' '}
                            <FormattedMessage id="programasPreventivosGridFiltros.buscar" defaultMessage="Buscar" />
                        </button>
                    </Grid>
                </Grid>

            </Grid>
        </Collapse>
    );
};

export default ProgramasPreventivosGridFiltros;
